import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-planning-item',
  templateUrl: './participant-planning-item.component.html',
  styleUrls: ['./participant-planning-item.component.scss']
})
export class ParticipantPlanningItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
